module.exports = __webpack_public_path__ + "img/our.749dbf7f.png";